import * as Yup from 'yup';

export const validationSchemaFormPhones = Yup.object({
  phone: Yup.string()
    .required('Поле обязательно для заполнения')
    .length(17, 'Невалидный номер телефона'),
});
